import type { CashLocationType } from './cash-locations.dto.js';
import type {
  CashReportCashLocationRefDto,
  CashReportCategoryBreakdownDto,
} from './cash-report-common.dto.js';

export const cashPositionScopeValues = ['station', 'location', 'company'] as const;
export type CashPositionScope = (typeof cashPositionScopeValues)[number];

export interface CashPositionTotalsDto {
  totalIn: number;
  totalOut: number;
}

export interface CashPositionCustodyClassificationDto {
  pendingTreasurySourceOffsetMinor: number;
  awaitingDestinationConfirmationMinor: number;
  activePreparedReservationMinor: number;
  availableBalance: number;
}

export interface CashPositionItemDto {
  cashLocationId: string;
  kind: CashLocationType;
  scope: CashPositionScope;
  storeId: string | null;
  locationId: string | null;
  stationId: string | null;
  balance: number;
  denominationInventoryActive: boolean;
  lastMovementAt: string | null;
  totals?: CashPositionTotalsDto;
  cashLocation?: CashReportCashLocationRefDto;
  categoryBreakdown?: CashReportCategoryBreakdownDto[];
  custodyClassification?: CashPositionCustodyClassificationDto;
}

export interface GetCashPositionRequest {
  companyId: string;
  storeId?: string;
  locationId?: string;
  stationId?: string;
  includeStationScopedDrawers?: boolean;
  includeZero?: boolean;
  asOf?: string;
}

export interface GetCashPositionResponse {
  items: CashPositionItemDto[];
}
